import { Injectable, OnDestroy } from "@angular/core";
import { HeaderService } from "src/app/angular-core/services/header.service";

/**
 * A base class for components to extend that ensures the header title is reset again when navigating away
 */
@Injectable()
export abstract class HeaderTitleProviderBase implements OnDestroy {
  constructor(
    private headerService: HeaderService
  ) {
  }

  protected setHeaderTitle(title: string): void {
    this.headerService.setTitleOverride(title);
  }

  public ngOnDestroy(): void {
    this.headerService.setTitleOverride(null);
  }
}